/**
 * @generated SignedSource<<81d1b8de15cc7be4dc05b1f67ad843c8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useViewedComments_read$data = {
  readonly commentIds: ReadonlyArray<string | null>;
  readonly " $fragmentType": "useViewedComments_read";
};
export type useViewedComments_read$key = {
  readonly " $data"?: useViewedComments_read$data;
  readonly " $fragmentSpreads": FragmentRefs<"useViewedComments_read">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useViewedComments_read",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "commentIds"
    }
  ],
  "type": "ViewedComments"
};

(node as any).hash = "8133cc01831582777d2e0911570e19eb";

export default node;
